/**
 * Calculate totals from detail rows
 */
export const calculateTotals = (detailRows: MuaHangRecord[] = [], chiPhiRows: MuaHangRecord[] = []) => {
  const so_luong = Number(
    detailRows.reduce((sum: number, row: { so_luong: string }) => sum + (Number(row.so_luong) || 0), 0)
  );
  const gia_nt = Number(
    detailRows.reduce((sum: number, row: { gia_nt0: string }) => sum + (Number(row.gia_nt0) || 0), 0)
  );
  const thue =
    Math.round(
      Number(detailRows.reduce((sum: number, row: { thue_nt: string }) => sum + (Number(row.thue_nt) || 0), 0)) * 100
    ) / 100;
  const chi_phi =
    Math.round(
      Number(chiPhiRows.reduce((sum: number, row: { tien_cp_nt: string }) => sum + (Number(row.tien_cp_nt) || 0), 0)) *
        100
    ) / 100;
  const tong_tien =
    Math.round(
      Number(
        detailRows.reduce((sum: number, row: { tien_nt0: string }) => sum + (Number(row.tien_nt0) || 0), 0) +
          Number(chi_phi)
      ) * 100
    ) / 100;
  const chiet_khau = Number(
    detailRows.reduce((sum: number, row: { ck_nt: string }) => sum + (Number(row.ck_nt) || 0), 0)
  );

  const tong_thanh_toan = Number(tong_tien + thue);

  return {
    gia: gia_nt,
    so_luong,
    chi_phi,
    thue,
    tong_thanh_toan,
    tong_tien,
    chiet_khau
  };
};
